<script setup lang="ts">
import { useHubClient } from '@/data/Hubs/useHubClient'
import HubDialog, { type HubFormValues } from '@/modules/Workspaces/KnowledgeHub/Hubs/HubDialog.vue'
import { useWorkspaceContext } from '@/modules/Workspaces/useWorkspaceContext'
import { whenever } from '@vueuse/core'
import { useRouter } from 'vue-router'

const open = defineModel<boolean>({ required: true })
const { workspaceId } = useWorkspaceContext()
const hubClient = useHubClient({ workspaceId })
const router = useRouter()

const { isPending, error, reset, mutateAsync } = hubClient.createMutation()
whenever(() => !open.value, reset)

async function onSubmit(values: HubFormValues) {
  const hub = await mutateAsync({
    name: values.name,
    description: values.description,
  })
  open.value = false
  router.push({ name: 'Hub', params: { hubId: hub.id } })
}
</script>

<template>
  <HubDialog
    v-model="open"
    title="Create a new Hub"
    description="Hub details"
    submit-label="Create a new hub"
    :is-pending="isPending"
    :error="error || undefined"
    @submit="onSubmit"
  />
</template>
